import axios from "axios";
import { BACKEND_URL } from "../backendURL";


class DashboardNewService {

    getDashboardData = (token) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/dashboard-data/";

        return axios.get(api_url, config);
    }


    getDashboardTasks = (token) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/dashboard-member-tasks/";

        return axios.get(api_url, config);
    }


    getDashboardPoints = (token) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/dashboard-member-points/";

        return axios.get(api_url, config);
    }


    getDashboardMembers = (token) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/dashboard-partymembers-brought-by/";

        return axios.get(api_url, config);
    }


    getMonthlyTaskReport = (token) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/statistics/monthtaskstatusreport/";

        return axios.get(api_url, config);
    }


    getMemberAddReport = (token, regionId) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/statistics/memberaddedreport/?region=" + regionId;

        return axios.get(api_url, config);
    }


    getRegionVoterMemberReport = (token, regionId) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/statistics/votermemberreport/?region_id=" + regionId;

        return axios.get(api_url, config);
    }


    getMunicipalityVoterMemberReport = (token, municipalityId) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/statistics/votermemberreport/?municipality_id=" + municipalityId;

        return axios.get(api_url, config);
    }


    getNationVoterMemberReport = (token) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/statistics/votermemberreport/";

        return axios.get(api_url, config);
    }


    getMunicipalityPartyMemberRoles = (token, municipalityId) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/memberpartyrole/?municipality_id=" + municipalityId;

        return axios.get(api_url, config);
    }


    getNationPartyMemberRoles = (token) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/memberpartyrole/";

        return axios.get(api_url, config);
    }


    getRegionPartyMemberRoles = (token, regionId) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/memberpartyrole/?region_id=" + regionId;

        return axios.get(api_url, config);
    }

    getMemberMobilityYearReport = (token, region) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        let api_url = BACKEND_URL + "/api/statistics/party-members-mobility/"
        if (region) {
            api_url = api_url + "?region=" + region;
        }

        return axios.get(api_url, config);
    }

    getGeneralVoterMemberReport = (token, region, municipality) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        let api_url = BACKEND_URL + "/api/statistics/voter-member-report/";
        if (region) {
            api_url = api_url + "?region_id=" + region;
        }
        if (municipality) {
            api_url = api_url + "?municipality_id=" + municipality;
        }

        return axios.get(api_url, config);
    }

    getYearlyTaskReport = (token) => {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };
        const api_url = BACKEND_URL + "/api/statistics/yearly-task-report/";
        return axios.get(api_url, config);
    }


}

export default new DashboardNewService();